var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 52.478,
    viewBox: "0 0 48 52.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-cashapp",
    "data-name": "Icon simple-cashapp",
    d: "M47.18,7.591A10.724,10.724,0,0,0,41.08.919C38.46,0,36.08,0,31.24,0H16.72c-4.8,0-7.22,0-9.8.875A10.728,10.728,0,0,0,.82,7.569C0,10.412,0,13.037,0,18.287v15.9c0,5.272,0,7.875.8,10.719a10.724,10.724,0,0,0,6.1,6.672c2.6.9,5,.9,9.8.9H31.26c4.82,0,7.22,0,9.8-.875a10.724,10.724,0,0,0,6.12-6.694c.82-2.844.82-5.469.82-10.719V18.331c0-5.272,0-7.9-.82-10.741ZM34.84,17.719l-1.86,2.034a.937.937,0,0,1-1.34.022,9.5,9.5,0,0,0-6.44-2.581c-1.94,0-3.88.7-3.88,2.647,0,1.969,2.08,2.625,4.48,3.609,4.2,1.531,7.68,3.456,7.68,7.962,0,4.9-3.48,8.269-9.16,8.641l-.52,2.625a1.006,1.006,0,0,1-.96.853H19.26l-.18-.022a1.1,1.1,0,0,1-.76-1.291l.56-2.778a12.793,12.793,0,0,1-5.76-3.434v-.022a1.121,1.121,0,0,1,0-1.487l2-2.122a.92.92,0,0,1,1.34,0,9.233,9.233,0,0,0,6.78,2.888c2.6,0,4.34-1.2,4.34-3.106s-1.76-2.406-5.08-3.763c-3.52-1.378-6.86-3.325-6.86-7.875,0-5.294,4.02-7.875,8.78-8.116l.5-2.691a.982.982,0,0,1,.96-.831h3.56l.2.022a1.05,1.05,0,0,1,.74,1.247l-.54,3a14.711,14.711,0,0,1,4.96,3.041l.04.044a1.113,1.113,0,0,1,0,1.487Z",
    fill: "#63c3d1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneda);
export default __webpack_public_path__ + "static/media/moneda.962632afd88ced3127f9eb8fc149ebf2.svg";
export { ForwardRef as ReactComponent };